import React from 'react';
// import PropTypes from 'prop-types';
import Select from '../Select';
import { MessageHelp, MessageAlert, Label } from '../../typography';
import { SelectWrapper } from './styles';

/* eslint react/prop-types: 0 */
function FormSelect({
  disabled,
  innerRef,
  name,
  type,
  label,
  value,
  async,
  asyncOptions,
  onKeyDown,
  onChangeOverride,
  help,
  style,
  placeholder,
  readOnly,
  noMargin,
  options,
  getOptionLabel,
  getOptionValue,
  accessor,
  getFullOption,
  autoFocus,
  // formik
  values,
  errors,
  touched,
  setFieldValue,
  setFieldTouched,
}) {
  const error = !!errors[name] && !!touched[name];
  const success = !errors[name] && !!touched[name];

  return (
    <SelectWrapper style={style} error={error} help={help} noMargin={noMargin}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <Select
        style={{ marginBottom: 10 }}
        autoFocus={autoFocus}
        success={success}
        error={error}
        help={help}
        readOnly={readOnly}
        aria-readonly={readOnly}
        aria-label={label}
        disabled={disabled}
        placeholder={placeholder}
        ref={innerRef}
        type={type}
        id={name}
        name={name}
        value={value || values[name]}
        onChange={onChangeOverride || (v => setFieldValue(name, v))}
        onBlur={() => setFieldTouched(name, true, true)}
        onKeyDown={onKeyDown}
        options={options}
        async={async}
        asyncOptions={asyncOptions}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        accessor={accessor}
        getFullOption={getFullOption}
      />
      {help && !error && <MessageHelp>{help}</MessageHelp>}
      {error ? <MessageAlert>{errors[name]}</MessageAlert> : null}
    </SelectWrapper>
  );
}

export default FormSelect;
